"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = void 0;
const axios_1 = __importDefault(require("axios"));
const HttpStatusCodes_1 = require("../enums/HttpStatusCodes");
exports.api = axios_1.default.create({
    baseURL: process.env.NEXT_API_URL, // Base backend URL would be defined here.
});
exports.api.interceptors.response.use((response) => {
    return response.data;
}, (error) => {
    var _a, _b, _c;
    const message = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || error.message;
    console.log(message);
    if (((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === HttpStatusCodes_1.HttpStatusCodes.UNAUTHORIZED) {
        // redirect to login
    }
    return Promise.reject(error);
});
